import {
  // CORE_LOAD_LOCATIONS_REPORT_SUCCESS,
  // CORE_LOAD_LOCATIONS_REPORT_REQUEST,

  // CORE_LOAD_REPORTSUMMARY_SUCCESS,
  // CORE_LOAD_REPORTSUMMARY_REQUEST,

  // CORE_LOAD_USERREPORT_REQUEST,
  // CORE_LOAD_USERREPORT_SUCCESS,

  // CORE_LOAD_ROOMREPORT_REQUEST,
  // CORE_LOAD_ROOMREPORT_SUCCESS,

  // CORE_LOAD_USERSUMMARY_REQUEST,
  // CORE_LOAD_USERSUMMARY_SUCCESS,

  // CORE_LOAD_REPORT_SUCCESS,
  // CORE_LOAD_REPORT_REQUEST,

  CORE_LOAD_EVENTREPORT_REQUEST,
  CORE_LOAD_EVENTREPORT_SUCCESS,

  CORE_LOAD_ADMINREPORT_REQUEST,
  CORE_LOAD_ADMINREPORT_SUCCESS,

  CORE_SEARCH_EVENTS_REQUEST,
  CORE_SEARCH_EVENTS_SUCCESS,

  CORE_CANCEL_EVENT_REQUEST,
  CORE_CANCEL_EVENT_SUCCESS,

  CORE_REOPEN_EVENT_REQUEST,
  CORE_REOPEN_EVENT_SUCCESS,
} from '../../types'

const initialState = []
export default {
  // coreRoom: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_LOCATIONS_REPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_LOCATIONS_REPORT_SUCCESS:
  //       if (action.payload[0]) {
  //         let payload = action.payload[0]
  //         let locations = []
  //         for (let i = 0; i < payload.length; i++) {
  //           locations.push({
  //             value: payload[i].email,
  //             key: i,
  //             text: payload[i].name,
  //             name: payload[i].name,
  //           })
  //         }
  //         return locations
  //       }
  //       else return [{}]

  //     default:
  //       return state
  //   }
  // },
  // statusSum: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_REPORTSUMMARY_REQUEST:
  //       return initialState

  //     case CORE_LOAD_REPORTSUMMARY_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // roomReports: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_REPORT_REQUEST:
  //       return initialState
  //     case CORE_LOAD_REPORT_SUCCESS:
  //     let data = []
  //       if(action.payload !== ''){
  //         const {actionlog} = action.payload
  //         actionlog.data.forEach(payload => {
  //           let createEvent = false
  //           let updateEvent = false
  //           let deleteEvent = false
  //           let type = payload.meta.type
  //           if(type === "CREATE_EVENT") createEvent = true
  //           else if(type === "UPDATE_EVENT") updateEvent = true
  //           else deleteEvent = true
  //           data.push({
  //             startDateTimeThai: payload.meta.data.startDateTimeThai,
  //             endDateTimeThai: payload.meta.data.endDateTimeThai,
  //             organizerAddress:payload.meta.data.organizer.emailAddress.name,
  //             subject:payload.meta.data.subject,
  //             _id:payload._id,
  //             createEvent: createEvent,
  //             updateEvent:updateEvent,
  //             deleteEvent:deleteEvent,
  //             message:payload.meta.message,
  //             meetnow: payload.meta.meetnow ? true: false
  //           })
  //         });
  //         return data
  //       }
  //       return action.payload

  //     default:
  //       return state
  //   }
  // },
  // userReport: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_USERREPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_USERREPORT_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // roomReport: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_ROOMREPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_ROOMREPORT_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // userSum: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_USERSUMMARY_REQUEST:
  //       return initialState

  //     case CORE_LOAD_USERSUMMARY_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //             summary : payload.summary
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  eventReport: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_EVENTREPORT_REQUEST:
        return initialState
      case CORE_LOAD_EVENTREPORT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  adminReport: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ADMINREPORT_REQUEST:
        return initialState
      case CORE_LOAD_ADMINREPORT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  searchEvents: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SEARCH_EVENTS_REQUEST:
        return initialState
      case CORE_SEARCH_EVENTS_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  eventAction: (state = initialState, action) => {
    switch (action.type) {
      case CORE_CANCEL_EVENT_REQUEST:
      case CORE_REOPEN_EVENT_REQUEST:
        return initialState
      case CORE_CANCEL_EVENT_SUCCESS:
      case CORE_REOPEN_EVENT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/report/reducer.js